// ============================================================================
// REORGANIZED API HOOKS - MODULAR STRUCTURE
// ============================================================================
//
// This file re-exports all API hooks from the organized modules.
// The actual implementations are now split into smaller, focused files:
//
// - api/types.ts: All shared types and interfaces
// - api/utils.ts: Shared utilities and helper functions
// - api/dashboard.ts: Dashboard-related hooks
// - api/tickets.ts: Ticket-related hooks
// - api/contacts.ts: Contact/client-related hooks
// - api/time-entries.ts: Time entry-related hooks
// - api/admin.ts: Admin user management hooks
// - api/reports.ts: Report and metrics hooks
// - api/client-portal.ts: Client portal hooks
// - api/quickbooks.ts: QuickBooks integration hooks
//
// ============================================================================

// Re-export everything from the organized API modules
export * from "./api";

// ============================================================================
// BACKWARD COMPATIBILITY
// ============================================================================
//
// All existing imports will continue to work exactly as before.
// No changes needed to existing components or files.
//
// Example usage remains the same:
// import { useTickets, useContacts, useTimeEntries } from "@/lib/hooks/use-api";
//
// ============================================================================
